const getColLength = (c) => Array.isArray(c.name) ? c.name.length : 1;
export default (columns) => Math.max(...columns.map(getColLength));
